<template>
	<div class="c-full-empty">
		<img :src="emptySvg || NON_DATA" alt="" />
		<div>{{ emptyText || $t('enterprise.no-data') }}</div>
	</div>
</template>

<script>
import NON_DATA from '@/assets/images/irstore/non_data.svg';

export default {
	props: {
		emptySvg: {
			type: String,
			default: ''
		},
		emptyText: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			NON_DATA
		};
	}
};
</script>

<style lang="less" scoped>
.c-full-empty {
	height: 100%;
	padding-bottom: 0.12rem;
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	img {
		width: 1.2rem;
		height: 1.2rem;
	}
	div {
		margin-top: 0.06rem;
		color: #8e8d8c;
		font-family: 'PingFang SC';
		font-size: 0.13rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.18rem;
	}
}
</style>
